import React from 'react';
import { QueryHookOptions } from '@apollo/client';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useQuery } from '@ts-gql/apollo';

import { getJobCommentType } from '../globals';

export const GET_JOB_COMMENTS_QUERY = gql`
  query GetJobComments($cloudId: String!) {
    getJob(cloudId: $cloudId) {
      cloudId
      comments {
        cloudId
        comment
        commentType
        wfCreatedBy
        wfCreatedOnUtc
        WfModifiedOnUtc
        wfDeletedOnUTC
      }
    }
  }
` as import('../../__generated__/ts-gql/GetJobComments').type;
export type GetJobCommentsVariables = OperationVariables<
  typeof GET_JOB_COMMENTS_QUERY
>;
export type GetJobCommentsResult = OperationData<typeof GET_JOB_COMMENTS_QUERY>;
export type GetJobCommentsGqlJob = NonNullable<GetJobCommentsResult['getJob']>;
export type GetJobCommentsGqlComment = NonNullable<
  GetJobCommentsGqlJob['comments']
>[number];

export type GetJobCommentsJob = NonNullable<
  ReturnType<typeof gqlCommentToJobComment>
>;

export type GetJobCommentsItem = NonNullable<
  ReturnType<typeof gqlCommentToJobComment>
>;

export const useGetJobComments = (
  options: QueryHookOptions<GetJobCommentsResult, GetJobCommentsVariables>
) => {
  const variables = options.variables as GetJobCommentsVariables;
  const res = useQuery(GET_JOB_COMMENTS_QUERY, {
    context: { service: 'core' },
    variables,
    ...options,
  });
  return React.useMemo(() => {
    const { data } = res;
    return {
      ...res,
      data: data?.getJob ? gqlJobToResultJob(data.getJob) : null,
    };
  }, [res]);
};

function gqlJobToResultJob(job: GetJobCommentsGqlJob) {
  const data = job && {
    ...job,
    comments: (job.comments && job.comments.map(gqlCommentToJobComment)) || [],
  };
  return data;
}

function gqlCommentToJobComment(comment: GetJobCommentsGqlComment) {
  const data = comment && {
    ...comment,
    commentType: comment.commentType
      ? getJobCommentType(comment.commentType)
      : undefined,
    wfCreatedOnUtc: comment.wfCreatedOnUtc && new Date(comment.wfCreatedOnUtc),
    wfDeletedOnUTC: comment.wfDeletedOnUTC && new Date(comment.wfDeletedOnUTC),
    WfModifiedOnUtc:
      comment.WfModifiedOnUtc && new Date(comment.WfModifiedOnUtc),
  };
  return data;
}
